import BaseComponent from '../../../../common/js/BaseComponent';

export default class PromoBar extends BaseComponent {
    init(): any {
        this.initCloseEvt();
    }

    initCloseEvt() {
        const btnClose = this.view.querySelector('.btn-promo-close');
        btnClose?.addEventListener('click', () => {
            this.view.classList.add('d-none');
        });
    }
}
